import { j as r } from "../../../../jsx-runtime-CQ7OqOhn.js";
import { syfLoaderStyles as t } from "./SyfLoader.styles.js";
import "../../../../tailwindConfig/colors/index.js";
import "../../../../tailwindConfig/fontSize/fontSize.js";
import "../../../../tailwindConfig/plugins/gradientUtilities.plugin.js";
import "../../../../tailwindConfig/plugins/rootStyles.plugin.js";
import "@tailwindcss/container-queries";
import "@tailwindcss/aspect-ratio";
import o from "../../../../tailwindConfig/bclTwMerge.js";
import p from "../../../../utilities/tw.js";
const s = p`bg-gold-300`, N = ({
  size: e = 1,
  id: i = "syf-loader",
  className: m = "",
  leftBarColor: a = s,
  middleBarColor: l = s,
  rightBarColor: d = s
}) => /* @__PURE__ */ r.jsxs(
  "div",
  {
    id: i,
    className: o(t.container, m),
    style: { height: `${16 * e}px`, width: `${12.12 * e}px` },
    children: [
      /* @__PURE__ */ r.jsx("div", { className: o(t.leftBar, a) }),
      /* @__PURE__ */ r.jsx("div", { className: o(t.middleBar, l) }),
      /* @__PURE__ */ r.jsx("div", { className: o(t.rightBar, d) })
    ]
  }
);
export {
  N as default
};
